import { logger } from '#pplx/frontend/logger/browser.js';
export function shouldDelegateEvent() {
    if (typeof window === 'undefined')
        return false;
    const w = window;
    return !!(w?.webkit?.messageHandlers?.pplx?.postMessage || w?.Android?.pplx?.postMessage);
}
export function sendNativeEvent({ type, data }) {
    if (typeof window === 'undefined')
        return false;
    const w = window;
    const d = { type, data };
    if (w?.webkit?.messageHandlers?.pplx?.postMessage) {
        w.webkit.messageHandlers.pplx.postMessage(d);
        return true;
    }
    if (w?.Android?.pplx?.postMessage) {
        w.Android.pplx.postMessage(d);
        return true;
    }
    return false;
}
/** When rendered in a webview, call this function to tell the apps to create a thread.
 *  Pass `isComputerTask` to route the query to a native Computer thread
 *  (`pplx.ask_computer`) instead of a standard ask thread (`pplx.ask`). */
export function createNativeThread({ query, isComputerTask = false, }) {
    return sendNativeEvent({
        type: isComputerTask ? 'pplx.ask_computer' : 'pplx.ask',
        data: { query },
    });
}
function compareSemver(v1, v2) {
    const parts1 = v1.split('.').map(Number);
    const parts2 = v2.split('.').map(Number);
    for (let i = 0; i < 3; i++) {
        const p1 = parts1[i];
        const p2 = parts2[i];
        if (p1 === undefined || p2 === undefined)
            return 0;
        if (p1 > p2)
            return 1;
        if (p1 < p2)
            return -1;
    }
    return 0;
}
export function isSupportedVersion(currAppVersion, currAppClient, minVersions) {
    try {
        if (!currAppVersion || !currAppClient)
            return false;
        const minVersion = minVersions[currAppClient];
        if (!minVersion)
            return true;
        return compareSemver(currAppVersion, minVersion) >= 0;
    }
    catch (e) {
        // fail closed
        logger.error('Error comparing canonical page semver', { e });
        return false;
    }
}
//# sourceMappingURL=nativeBridge.js.map